import { useEffect, useState } from 'react';
import ReuseableTable from '../../table/ReuseableTable';
import useGetMarketingData from '../../../hooks/marketing/useGetMarketingData';
import { createRow, headerCells } from '../../../utils/table/campaignsTable';
import CampaignSideBarModal from '../CampaignSideBarModal';
import useCampaignActions from '../../../hooks/marketing/useCampaignActions';
import useCampaignEditor from '../../../hooks/marketing/useCampaignEditor';
import useUser from '../../../hooks/global/useUser';
import { LoadedUser } from '../../../interfaces';
import { CampaignEditorProvider } from '../../../context/CampaignEditorContext';

function CampaignsTableContent() {
  const { user } = useUser<LoadedUser>();
  const editor = useCampaignEditor();
  const [selectedViewCampaignId, setSelectedViewCampaignId] = useState<
    string | null
  >(null);

  const { data, isLoading } = useGetMarketingData();

  const { handlers, isPending: disableActions } = useCampaignActions({
    onSelectCampaign: setSelectedViewCampaignId,
    openEditor: editor.open,
  });

  const selectedViewCampaign =
    data?.campaigns?.find(campaign => campaign.id === selectedViewCampaignId) ||
    null;

  // Campaign deleted while sidebar was open → clear stale id.
  useEffect(() => {
    if (!isLoading && selectedViewCampaignId && !selectedViewCampaign) {
      setSelectedViewCampaignId(null);
    }
  }, [isLoading, selectedViewCampaignId, selectedViewCampaign]);

  return (
    <>
      <ReuseableTable
        name="Campaigns"
        emptyMessage="No campaigns have been created yet"
        headerCells={headerCells}
        loading={isLoading}
        rows={
          data?.campaigns?.map(campaign =>
            createRow(campaign, {
              user,
              handlers,
              disableActions,
            }),
          ) ?? []
        }
      />
      <CampaignSideBarModal
        campaign={selectedViewCampaign}
        isOpen={!!selectedViewCampaignId}
        onClose={() => setSelectedViewCampaignId(null)}
        actionHandlers={handlers}
        disableActions={disableActions}
      />
    </>
  );
}

function CampaignsTable() {
  return (
    <CampaignEditorProvider>
      <CampaignsTableContent />
    </CampaignEditorProvider>
  );
}

export default CampaignsTable;
